import React, { memo } from 'react';

import DropdownMC from '../../../../../components/DropdownMC';
import DatePickerMC from '../../../../../components/DatePickerMC';
import ToggleSwitchMC from '../../../../../components/ToggleSwitchMC';
import CurrencyInputMC from '../../../../../components/CurrencyInputMC';
import InputComponent from '../../../../../components/InputMC';

const CustomFieldRenderer = ({
  field,
  getValues,
  updateCustomField,
  handleInputChange,
  handleBooleanToggle,
  toggleKey,
  error
}) => {
  switch (field.kind) {
    case 'list': {
      const options = field.list_options.map((o) => ({
        ...o,
        id: String(o.id)
      }));

      const selectedAnswer = getValues('customAnswers')?.find(
        (ca) => ca.custom_field_id === field.id
      )?.answer;

      // Find the option id that matches the saved answer value
      const selectedOptionId = selectedAnswer
        ? field.list_options.find((o) => String(o.value) === String(selectedAnswer))?.id
        : '';

      return (
        <div className="tw-w-full">
          <DropdownMC
            id={`customFields.${field.name}`}
            name={`customFields.${field.name}`}
            label={field.label}
            options={options}
            defaultValue={selectedOptionId ? String(selectedOptionId) : ''}
            useFloatingLabel
            onSelect={(opt) => updateCustomField(field, opt)}
          />
        </div>
      );
    }

    case 'date':
      return (
        <div className="tw-w-full">
          <DatePickerMC
            name={`customFields.${field.name}`}
            label={field.label}
            onChange={(date) => updateCustomField(field, date)}
            showMonthDropdown
            showYearDropdown
            dateFormat="dd-MM-yyyy"
            className="tw-mb-4"
          />
        </div>
      );

    case 'boolean':
      return (
        <div className="tw-flex tw-w-full tw-flex-col">
          <ToggleSwitchMC
            key={toggleKey}
            isOn={getValues(`customFields.${field.name}`)}
            handleToggle={() => handleBooleanToggle(field)}
            label={field.label}
            labelClassName="!tw-text-xs !tw-font-semibold"
            required={field.required}
          />
          {error && (
            <span className="tw-text-red-500 tw-text-xs tw-mt-1">
              {error.message}
            </span>
          )}
        </div>
      );

    case 'float':
      return (
        <div className="tw-w-full">
          <CurrencyInputMC
            id={`customFields.${field.name}`}
            name={`customFields.${field.name}`}
            label={field.label}
            useFloatingLabel
            onChange={(event) => handleInputChange(event, field)}
          />
        </div>
      );

    default:
      return (
        <div className="tw-w-full">
          <InputComponent
            id={`customFields.${field.name}`}
            name={`customFields.${field.name}`}
            label={field.label}
            className="tw-resize-none"
            useFloatingLabel
            onChange={(name, value) => handleInputChange({ target: { name, value } }, field)}
          />
        </div>
      );
  }
};

export default memo(CustomFieldRenderer);
